module.exports = __webpack_public_path__ + "files/bf0b0b4245b6ec30b91edda5be1b99d0.png";